module.exports = __webpack_public_path__ + "media/images/SWB_header-76a0ec1d361999ff681e353ee5a96528.jpg";